import styled from 'styled-components';

export const StatesContinentsListItemLink = styled.a`
    color: rgba(255,255,255,0.5);
    text-decoration: none;
`;